import { dateToISO } from '@agilox/common';
import { Pipe, PipeTransform } from '@angular/core';
import { FailuresEntry } from '../../../menupoints/failures/failures-history/data/failures-entry';
import { FailureCategoryKey } from '../services/failure-order-workflow/failure-category.enum';

@Pipe({
	name: 'failuresHeatmapCategoryFilter',
})
export class FailuresHeatmapCategoryFilterPipe implements PipeTransform {
	transform(data: FailuresEntry[], filter: string[] | null): any {
		if (data.length > 0) {
			const getFailures = (data: FailuresEntry, categories: string[]) => {
				if (!categories?.length) {
					return 0;
				}

				return categories.reduce((errors, category) => {
					switch (category.toLowerCase()) {
						case FailureCategoryKey.ERROR.toLowerCase():
							return errors + data.errors;
						case FailureCategoryKey.PROBLEM.toLowerCase():
							return errors + data.problems;
						case FailureCategoryKey.WARNING.toLowerCase():
							return errors + data.warnings;
						default:
							return errors;
					}
				}, 0);
			};
			return data.map((entry) => {
				return {
					date: dateToISO(new Date(entry.start)),
					val: getFailures(entry, filter),
				};
			});
		} else {
			return [];
		}
	}
}
